import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Ticket, ThumbsUp, Clock, Star } from "lucide-react";
import CreateTicketModal from "../Modal/CreateTicketModal";
import CreateTaskModal from "../Task/Modal/CreateTaskModal";
import FrameBG from "../../Assets/FrameBGDashboard.png";
const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);
  // Dummy data
  const supportData = [
    { date: "25 Dec", opened: 25, closed: 30 },
    { date: "26 Dec", opened: 28, closed: 20 },
    { date: "27 Dec", opened: 22, closed: 25 },
    { date: "28 Dec", opened: 30, closed: 22 },
    { date: "29 Dec", opened: 32, closed: 27 },
    { date: "30 Dec", opened: 34, closed: 15 },
    { date: "31 Dec", opened: 38, closed: 10 },
  ];

  const channelData = [
    { name: "Assigned", value: 43, color: "#D1E3FF" },
    { name: "Rejected", value: 21, color: "#FFD166" },
    { name: "Approved", value: 12, color: "#8ECAE6" },
    { name: "Ready to Review", value: 3, color: "#219EBC" },
  ];

  const busiestData = [
    { name: "Shyam", median: 50, percentile: 100 },
    { name: "Harshada", median: 400, percentile: 800 },
    { name: "Viyash", median: 300, percentile: 500 },
    { name: "Sanchit", median: 300, percentile: 1100 },
    { name: "Anish", median: 400, percentile: 700 },
    { name: "Abhay", median: 350, percentile: 800 },
    { name: "Sanket", median: 400, percentile: 780 },
  ];

  const totalTickets = channelData.reduce((sum, c) => sum + c.value, 0);

  return (
    <>
      <div className="relative z-10 space-y-6">
        {/* Banner */}
        <div
          className="relative rounded-lg overflow-hidden shadow-md text-white"
          style={{
            backgroundImage: `url(${FrameBG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="p-8 flex justify-between items-center">
            <div>
              <h2 className="text-xl font-semibold">You're all set!</h2>
              <p className="text-sm opacity-90">
                Create a ticket to report bugs, submit requests, or track work
                items.
              </p>
            </div>
            <div>
              
            <button
              onClick={() => setShowTaskModal(true)}
              className="bg-[#003a63] text-white px-5 py-2 rounded-lg me-3"
            >
              Add Task
            </button>

            <button
              onClick={() => setShowModal(true)}
              className="bg-[#003a63] text-white px-5 py-2 rounded-lg"
            >
              Add Ticket
            </button>
            </div>
          </div>
        </div>

        {/* Insights Header */}
        <div className="flex items-center mb-3">
          <h3 className="text-xl font-semibold text-gray-700 me-3">Insights</h3>
          <select
            className="rounded-md px-3 py-1 text-sm text-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500"
            defaultValue="thisWeek"
          >
            <option value="thisWeek">This Week</option>
            <option value="thisMonth">This Month</option>
            <option value="thisYear">This Year</option>
          </select>
        </div>

        {/* Insights Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
          {/* Ticket Created */}
          <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
            <div>
              <p className="text-gray-500">Ticket Created</p>
              <h2 className="text-2xl font-bold mt-1">23</h2>
            </div>
            <div className="p-2 rounded-full">
              <Ticket className="w-8 h-9" />
            </div>
          </div>

          {/* Reviewed Satisfaction */}
          <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
            <div>
              <p className="text-gray-500">Reviewed Tickets</p>
              <h2 className="text-2xl font-bold mt-1">4</h2>
            </div>
            <div className="p-2 rounded-full">
              <ThumbsUp className="w-8 h-9" />
            </div>
          </div>

          {/* Avg. Resolution Time */}
          <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
            <div>
              <p className="text-gray-500">Avg. Resolution Time</p>
              <h2 className="text-2xl font-bold mt-1">10:34s</h2>
            </div>
            <div className="p-2 rounded-full">
              <Clock className="w-8 h-9" />
            </div>
          </div>

          {/* Performance Score */}
          <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
            <div>
              <p className="text-gray-500">Performance Score</p>
              <h2 className="text-2xl font-bold mt-1">4.5</h2>
            </div>
            <div className="p-2 rounded-full">
              <Star className="w-8 h-9" />
            </div>
          </div>
        </div>

        {/* Support Volume + Channel Conversation */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Support Volume Chart */}
          <div className="bg-white/90 backdrop-blur-[1px] p-4 rounded-lg shadow">
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-semibold">Tickets Volume</h3>
              <div className="flex justify-between items-center mb-3"></div>
              <select
                className="rounded-md px-3 py-1 text-sm text-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500"
                defaultValue="thisWeek"
              >
                <option value="thisWeek">This Week</option>
                <option value="thisMonth">This Month</option>
                <option value="thisYear">This Year</option>
              </select>
            </div>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={supportData}>
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="opened"
                  stroke="#2563eb"
                  name="Tickets opened"
                />
                <Line
                  type="monotone"
                  dataKey="closed"
                  stroke="#facc15"
                  name="Tickets closed"
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* Channel Conversation Pie */}
          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center space-x-1">
                <h3 className="font-semibold text-gray-700">
                  Status of Tickets
                </h3>
              </div>
              <select
                className="bg-gray-100 text-gray-600 text-sm rounded-full px-3 py-1 focus:outline-none"
                defaultValue="thisYear"
              >
                <option value="thisWeek">This Week</option>
                <option value="thisMonth">This Month</option>
                <option value="thisYear">This Year</option>
              </select>
            </div>

            {/* Donut Chart + Legend */}
            <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
              {/* Donut Chart */}
              <div className="relative w-[450px] h-[280px]">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={channelData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={90}
                      outerRadius={120}
                      paddingAngle={2}
                    >
                      {channelData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>

                {/* Center Label */}
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                  <h2 className="text-4xl font-bold text-gray-800">
                    {totalTickets}
                  </h2>
                  <p className="text-gray-500 text-sm mt-1 text-center leading-tight">
                    Ticket from all channel
                  </p>
                </div>
              </div>

              {/* Legend */}
              <div className="mt-6 md:mt-0 md:ml-8 space-y-2">
                {channelData.map((item, i) => (
                  <div key={i} className="flex items-center space-x-2">
                    <div
                      className="w-3 h-3 rounded-sm"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <p className="text-gray-700 text-sm">
                      <span className="font-medium">{item.value}</span>{" "}
                      {item.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Busiest Time */}
        <div className="bg-white p-4 rounded-lg shadow">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold">Busiest time</h3>
            <span className="text-sm text-gray-500">This Week</span>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={busiestData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="median" fill="#BCD4E8" name="Median" />
              <Bar dataKey="percentile" fill="#13659C" name="90% percentile" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <CreateTicketModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onCreated={() => {}}
      />
      
      <CreateTaskModal
        show={showTaskModal}
        onClose={() => setShowTaskModal(false)}
        onCreated={() => {}}
      />
    </>
  );
};

export default Home;
